<template>
    <div v-if="transcription" style="display:flex;flex-direction: row;">
        <div class="content left">
            <div class="formRow">
                <h4>Transcription Status</h4>
                <span v-html="transcription.statusCode"></span>
            </div>
            <div class="formRow">
                <h4>Media Description</h4>
                <a :href="mediaPropertyHref"><span v-html="transcription.mediaProperty.description"></span></a>
            </div>
            <div class="formRow" v-if="transcription.mediaProperty.mediaType === 'Audio'">
                <h4>Audio Location</h4>
                <span v-html="transcription.mediaProperty.configuration.location"></span>
            </div>
            <div class="formRow" v-else-if="transcription.mediaProperty.mediaType === 'Video'">
                <h4>Video Location</h4>
                <span v-html="transcription.mediaProperty.configuration.sources[activeVideo].src"></span>
            </div>
            <div class="formRow">
                <h4>Caption File Location</h4>
                <span v-html="transcription.mediaProperty.configuration.closedCaptionsLocation" v-if="transcription.mediaProperty.mediaType === 'Audio'"></span>
                <span v-html="transcription.mediaProperty.configuration.tracks[activeVideo].src" v-else-if="transcription.mediaProperty.mediaType === 'Video'"></span>
            </div>
        </div>
        <div class="content right">
            <div v-if="transcription.mediaProperty.mediaType === 'Video' && videoLink" class="videoPreview">
                <h4>Video Preview</h4>
                <div v-if="transcription.mediaProperty.configuration.sources.length > 1">
                    <h4>Select Source</h4>
                    <select v-model="activeVideo" @change="getVideoLink">
                        <option v-for="source in transcription.mediaProperty.configuration.sources" :key="source.src" :value="source.order">{{ source.order + 1 }}</option>
                    </select>
                </div>
                <video controls :key="videoKey">
                    <source :key="videoLink.src" :src="videoLink.src" :type="videoLink.type">
                </video>
                <div>Not to scale</div>
            </div>
            <div class="formRow" v-if="transcription.mediaProperty.mediaType === 'Audio' && audioLink">
                <h4>Audio preview</h4>
                <div>
                    <audio controls>
                        <source :src="audioLink" :type="transcription.mediaProperty.configuration.fileType" :key="audioKey">
                    </audio>
                </div>
            </div>
            <div class="formRow">
                <textarea class="transcribed-text" v-model="transcription.transcribedText" @blur="saveTranscription('transcribedText')"></textarea>
            </div>
            <div class="formRow">
                <button @click="saveAndValidate" class="primary-button">Save and mark as Validated</button>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {storage} from '../../shared/storage';

export default {
    name: 'AITranscriptionEdit',
    data() {
        return {
            transcription: null,
            audioLink: null,
            audioKey: 0,
            videoLink: null,
            videoKey: 0,
            activeVideo: 0
        }
    },
    computed: {
        mediaPropertyHref: function() {
            return '/MediaPropertyEdit?ID=' + this.transcription.mediaProperty.id;
        }
    },
    async mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        this.transcription = await data.getAITranscription(urlParams.get('ID'));
        if(this.transcription.mediaProperty.mediaType === 'Audio')
            await this.getAudioLink();
        else if(this.transcription.mediaProperty.mediaType === 'Video')
            await this.getVideoLink();
    },
    methods: {
        getAudioLink: async function() {
            this.audioLink = await storage.getWasabiLink(this.transcription.mediaProperty.configuration.location, this.publicPermission === 'public-read');
            this.audioKey++;
        },
        getVideoLink: async function() {
            const source = this.transcription.mediaProperty.configuration.sources.find(sr => sr.order === parseInt(this.activeVideo));
            if(source) {
                this.videoLink = {
                    src: await storage.getWasabiLink(source.src, this.transcription.mediaProperty.configuration.public),
                    type: source.type
                }
                this.videoKey++;
            }
        },
        saveTranscription: async function(fieldName, showToasters = true) {
            let saveObject = {};
            if(fieldName) {
                saveObject.id = this.transcription.id;
                saveObject[fieldName] = this.transcription[fieldName];
            } else {
                saveObject = this.transcription;
            }
            const resp = await data.saveAITranscription(saveObject);
            if(showToasters) {
                if(resp.success) {
                    this.$toast.success('Text Saved');
                } else if(resp.errors) {
                    this.$toast.error(resp.errors);
                }
            }
        },
        saveAndValidate: async function() {
            this.uploading = true;
            this.transcription.statusCode = 'Validated';
            await this.saveTranscription('statusCode', false);
            let key;
            if(this.transcription.mediaProperty.mediaType === 'Audio') {
                key = this.transcription.mediaProperty.configuration.location;
                key = key.replace('/Audio/', '/VTTs/');
            }
            else if(this.transcription.mediaProperty.mediaType === 'Video') {
                key = this.transcription.mediaProperty.configuration.sources[parseInt(this.activeVideo)].src;
                key = key.replace('/Video/', '/VTTs/');
            }
            if(key.charAt(0) === '/')
                key = key.substring(1);
            key = key.split('.').splice(0, 1).concat('vtt').join('.');
            let file = new Blob([this.transcription.transcribedText], {type: 'text/vtt'});
            const resp = await data.uploadStorageObject(file, storage.bucketName(), key, 'public-read');
            if(resp.success) {
                this.$toast.success('File Saved and Uploaded');
            } else if(resp.errors) {
                this.$toast.error(resp.errors);
                this.uploading = false;
                this.transcription.statusCode = 'Processed';
                await this.saveTranscription('statusCode', false);
            }
        }
    }
}
</script>

<style scoped>
    .content {
        display: flex;
        flex-direction: column;
        padding-top: 30px;
    }
    .left {
        margin: 0 10px 0 50px;
        flex: 1 1 200px;
    }
    .right {
        margin-right:50px;
        flex: 1 1 400px;
    }
    .transcribed-text {
        width: 100%;
        max-width: 500px;
        height: 200px;
        margin: 20px 0;
    }
    .primary-button {
        height: 40px;
        width: 180px;
        border-radius: 5px;
        border-color: #036991;
        background-color: #036991;
        color: white;
        cursor: pointer;
        font-size: 16px;
    }
</style>